import React from 'react';
import { styled } from 'linaria/react';
import { Price as UIPrice } from '@jetshop/ui/Price';
import { theme } from '../Theming/Theming';
import { getFontSize } from '../Theming/helpers';

const PriceWrapper = styled('div')`
  font-family: ${theme.price.fontFamily};
  font-weight: ${theme.price.fontWeight};
  ${UIPrice.Normal} {
    color: ${theme.price.normal.color};
  }
  ${UIPrice.New} {
    color: ${theme.price.new.color};
  }
  ${UIPrice.Old} {
    color: ${theme.price.old.color};
  }
`;

const GridPriceWrapper = styled(PriceWrapper)`
  ${UIPrice.Wrapper} {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
  }
  ${UIPrice.Normal} {
    ${getFontSize(theme.price.normal.fontSize)};
  }
  ${UIPrice.New} {
    margin-right: 0.8rem;
    ${getFontSize(theme.price.new.fontSize)};
  }
  ${UIPrice.Old} {
    ${getFontSize(theme.price.old.fontSize)};
  }
`;

const PriceComp = ({ price, previousPrice, defaultPrice }) => {
  if (price?.incVat < defaultPrice?.incVat) previousPrice = defaultPrice;
  return <UIPrice price={price} previousPrice={previousPrice} />;
};

export const Price = ({ className, ...props }) => {
  return (
    <PriceWrapper className={className}>
      <PriceComp {...props} />
    </PriceWrapper>
  );
};

export const GridPrice = ({ className, ...props }) => {
  return (
    <GridPriceWrapper className={className}>
      <PriceComp {...props} />
    </GridPriceWrapper>
  );
};
